<template>
  <div class="bg">
    <div class="container">
      <div class="header">
        <p style="color:#526069;font-size: 18px">个人交易数据</p>
        <!-- <form action="http://test.sp.ddbes.com/sps/mp/print/user" method="post" >
          <input type="submit"  value="dayin"/>
        </form> -->
        <el-button type="primary" style="height: 35px;width: 126px;line-height: 10px;color: #fff;" @click="exportExcel" :disabled="excelBtn">导出报表</el-button>
      </div>
      <el-form ref="from" :inline="true" :model="formInline" class="demo-form-inline" style="text-align: left;width: 100%">
        <el-form-item label="订单编号:">
          <el-input class="ein" v-model="formInline.orderId" placeholder="请输入订单编号"></el-input>
        </el-form-item>

        <!-- <el-form-item class="efi" label="姓名:">
          <el-input class="ein"  v-model="formInline.user" placeholder="请输入姓名"></el-input>
        </el-form-item> -->
        <el-form-item class="efi" label="类型:">
          <el-select class="ein"  v-model="formInline.type" placeholder="请选账单类型">
            <el-option label="收入" value="2"></el-option>
            <el-option label="支出" value="1"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item class="efi" label="支付渠道:">
          <el-select  v-model="formInline.payType" placeholder="请选支付渠道">
            <el-option label="全部" value="0"></el-option>
            <el-option label="微信" value="2"></el-option>
            <el-option label="支付宝" value="3"></el-option>
            <el-option label="润泽钱包" value="1"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item class="efi" label="所属企业:">
          <el-select  v-model="formInline.companyId" placeholder="请选所属企业">
            <!-- <el-option label="全部" value=""></el-option> -->
            <el-option 
              :label="item.name" 
              :value="item.companyId" 
              v-for='item in companyList' 
              :key='item.companyId'
            />
          </el-select>
        </el-form-item>
      </el-form>
      <div class="header">
        <el-form ref="from" :inline="true" :model="formInline" class="demo-form-inline" style="text-align: left;">
          <el-form-item label="时间范围:">
            <el-date-picker
              v-model="dateTimes"
              type="datetimerange"
              :picker-options="pickerOptions"
              range-separator="至"
              value-format="yyyy-MM-dd HH:mm:ss"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              align="right">
            </el-date-picker>

            <!-- <el-col :span="11">
              <el-date-picker :clearable="false"   type="date" placeholder="选择查询起始时间" v-model="formInline.date1" style="width: 100%;"
                              value-format="yyyy-MM-dd" suffix-icon="el-icon-caret-bottom" @change="timeChange" ></el-date-picker>
            </el-col>
            <el-col :span="2" style="text-align: center;"> -</el-col>
            <el-col :span="11">
              <el-date-picker :clearable="false"  type="date" placeholder="选择查询结束时间" v-model="formInline.date2" style="width: 100%;"
                              value-format="yyyy-MM-dd" suffix-icon="el-icon-caret-bottom"></el-date-picker>
            </el-col> -->
          </el-form-item>
        </el-form>
        <div style="margin-right: 20px;">
          <el-button type="primary" style="height: 35px;line-height: 10px;" @click="getUserDealData(1)">查询</el-button>
          <el-button type="info" style="height: 35px;line-height: 10px;" @click="reset">重置</el-button>
        </div>
      </div>
       <total :data = "totalData"></total>
      <el-table
        :data="tableData"
        stripe
        :header-cell-style="cell"
        :row-style="row"
        style="width: 100%;">
        <el-table-column
          align="center"
          prop="refOrderId"
          label="订单编号"
          width="180">
        </el-table-column>
        <el-table-column
          align="center"
          prop="realname"
          label="姓名">
        </el-table-column>
         <el-table-column
          align="center"
          prop="companyName"
          label="所属企业">
        </el-table-column>
        <el-table-column
          align="center"
          prop="fundDirection"
          :formatter="typeFormat"
          label="类型">
        </el-table-column>
        <el-table-column
          align="center"
          prop="amount"
          :formatter="tofixed"
          label="金额(元)">
        </el-table-column>
        <el-table-column
          align="center"
          prop="channel"
          label="支付渠道"
          :formatter="channelFormat">
        </el-table-column>
        <el-table-column
          align="center"
          prop="tradeName"
          label="交易方">
        </el-table-column>

        <el-table-column
          align="center"
          prop="createTime"
          :formatter="dateFormat"
          label="时间">
        </el-table-column>

      </el-table>
      <el-pagination class="pagi"
        layout="prev, pager, next,jumper"
        :total="total"
        background
        @current-change='getUserDealData'
        >
      </el-pagination>
    </div>
  </div>
</template>

<script>
import { getUserDeal ,exportUserDeal,getCompanyList} from "@/api/finance";
import {downloadExcel} from '@/utils/downloadFetch'
import { toFixed,compareTime } from "@/utils";
import Total from '@/components/Total.vue'
import {shop_url} from '@/global';
export default {
  name: "",
  props: [""],
  components:{Total},
  data() {
    return {
      formInline: {
        user: "",
        orderId: "",
        type: "",
        start: "",
        end: "",
        payType:'',
        companyId: ''
      },
      total: 0,
      page: 1,
      pageSize: 10,
      tableData: [],
      dateTimes : '',
      totalData:{},
      excelBtn:false,
      pickerOptions: {
        shortcuts: [{
            text: '最近一周',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit('pick', [start, end]);
            }
          }, {
            text: '最近一个月',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit('pick', [start, end]);
            }
          }, {
            text: '最近三个月',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
              picker.$emit('pick', [start, end]);
            }
          }]
      },
      companyList: []
    };
  },
  watch: {
    dateTimes:function (val){
      console.log(val)
      this.formInline.start = val[0];
      this.formInline.end = val[1];
    }
  },
  mounted() {
    this.$nextTick(function () {
      
      this._getCompanyList();
    })
  },
  methods: {
    _getCompanyList() {
      getCompanyList().then(res => {
        console.log('company',res);
        this.companyList = res.data;
        this.formInline.companyId = this.companyList[0].companyId;
        this.getUserDealData(1);
      })
    },
    tofixed(row, column, cellValue) {
      return toFixed(cellValue);
    },
    cell() {
      return {
        textAlign: "center",
        color: "#526069",
        fontSize: "14px"
      };
    },
    row() {
      return {
        height: "36px",
        textAlign: "center",
        color: "#7d8893",
        fontSize: "14px"
      };
    },
    getUserDealData(page) {
    console.log(this.formInline);

      this.page = page;
      // let {date1,date2} = this.formInline;
      // let flag = compareTime(date1,date2);
      // if(flag){
        getUserDeal(this.formInline, page, this.pageSize)
          .then(res => {
            this.totalData = {
            totalInconme:res.data.totalInconme,
            wxPay:res.data.wxPay,
            aliPay:res.data.aliPay,
            rangePay:res.data.rangePay,
            totalPay:res.data.totalPay,
            totalCount:res.data.count,
            couponPay:res.data.couponPay || 0,
          }
            this.tableData = res.data.list;
            console.log(this.tableData);
            this.total = res.data.count;
          })
          .catch(error => {});
      // }else{
      //   this.$notify({
      //       title: "提示",
      //       message:'请正确选择时间',
      //       type:'warning',
      //       duration: 800
      //     });
      // }
    },
    exportExcel(){
      this.excelBtn = true;
      // this.formInline.start = this.formInline.date1;
      // this.formInline.end = this.formInline.date2;
      downloadExcel({method:'post',fileName:'个人交易数据报表.xls',url:`${shop_url}/shop/cms/print/user`,data:this.formInline}).then(res=>{
        console.log(res)
      }).then(res => {
        this.excelBtn = false;
        console.log(res);
      }).catch(err => {
        this.excelBtn = false;
      });
    },
    reset() {
      this.formInline.user = "";
      this.formInline.orderId = "";
      this.formInline.type = "";
      this.formInline.start = "";
      this.formInline.end = "";
      this.formInline.payType = "";
      this.getUserDealData(1);
    },

    dateFormat(row, column) {
      return this.uwsToDate(row[column.property]);
    },
    typeFormat(row, column) {
      // console.log(row, column);
      let str = "";
      switch (row[column.property]) {
        case 1:
          str = "支出";
          break;
        case 2:
          if(row.orderType == 5){
            str = "退款";
          } else{
            str = "收入";
          }
          break;
        case 5:
          str = "退款";
          break;
      }
      return str;
    },
    channelFormat(row, column){
      let str = "";
      switch (row[column.property]) {
        case 1:
          str = "园区钱包";
          break;
        case 2:
          str = "微信";
          break;
        case 3:
          str = "支付宝";
          break;
        case 4:
          str = "--";
          break;
      }
      return str;
    }
  }
};
</script>
<style scoped>
.container {
  background-color: #fff;
  padding: 30px;
  display: flex;
  flex-direction: column;
}
.header {
  display: flex;
  justify-content: space-between;
}
.el-input {
  border-bottom: 240px #d1dee1;
}
.ein {
  width: 240px;
}
.efi {
  margin-left: 20px;
}
.pagi {
  align-self: center;
  margin-top: 24px;
}
</style>



// WEBPACK FOOTER //
// src/pages/finance/UserDealData.vue